const RemoveFromCart = {
  init(target) {
    if (target) {
      const form = target
      form.addEventListener('submit', (e) => {
        e.preventDefault()
        this.submit(form)
      })
    }
  },

  async submit(form) {
    const button = form.querySelector('button[type=submit]')
    const callout = form.querySelectorAll('.callout')
    const data = new FormData(form)
    const action = form.getAttribute('action')
    const formMethod = form.getAttribute('method')

    if (callout) {
      callout.forEach((el) => el.remove())
    }

    button.disabled = true
    button.classList.add('button--loading')

    fetch(action, {
      method: formMethod,
      body: data,
    })
      .then((res) => res.json())
      .then(() => {
        window.location.reload()
      })
      .catch((ex) => {
        this.renderMessage(form, `Server error: ${ex}`, 'error')
      })
  },

  renderMessage(el, message, type) {
    el.insertAdjacentHTML('beforeend', `<div class="callout callout--${type}">${message}</div>`)
  },
}

export default RemoveFromCart
